// להחליף לאחר שיש שפות בשרת
import { api } from "./api";
import { TLanguage } from "../../types/types";

export const languagesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLanguages: build.query<TLanguage[], void>({
      query: () => ({
        url: "Languages/",
        method: "GET",
      }),
      transformResponse: (response: TLanguage[]) => {
        return response
          .filter((lang) => lang.statusId && typeof lang.code === 'string');
      },
      providesTags: ["language"]
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetLanguagesQuery,
} = languagesApi;
